/*
 * LanguageSelect
 */
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@psychology/react-ui"
import { useTranslation } from "react-i18next"
import { LocaleEnum } from "../intl.constants"

const localeLabels: Record<LocaleEnum, string> = {
	[LocaleEnum.enUS]: "English",
	[LocaleEnum.frCA]: "Français",
}

type LanguageSelectProps = {
	onAfterChange?: (locale: string) => void
}

export function LanguageSelect({ onAfterChange }: LanguageSelectProps) {
	const { i18n } = useTranslation()

	function handleValueChange(value: string) {
		i18n.changeLanguage(value)
		onAfterChange?.(value)
	}

	return (
		<Select value={i18n.language} onValueChange={handleValueChange}>
			<SelectTrigger className={"w-[100px]"}>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{Object.entries(localeLabels).map(([locale, label]) => (
					<SelectItem key={locale} value={locale}>
						{label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
